export default class BaseChange {
  setMessage(message) {
    this.message = message
  }

  messageObject() {
    if (this.message) {
      return this.message
    }
    else {
      return {}
    }
  }

  messageString() {
    return this.messageObject().message
  }

  isMoved()   { return false }
  isLoadUrl() { return false }

  loggingDetails() {
    return {
      name: this.constructor.name,
      type: this.type,
      message: this.messageString(),
    }
  }
}
